import React, { useState } from 'react'
import { retrieveOrder } from '../../services/api/consumer'
import { ConsumerOrderDetails } from '../../model'
import { useForm } from 'react-hook-form'
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage'
import Button from '../../components/Button/Button'
import DynamicFaIcon from '../../components/DynamicFaIcon/DynamicFaIcon'

interface ConfirmOrderVerifyProps {
    token?: string
    onVerified: (res: ConsumerOrderDetails) => void
}

const ConfirmOrderVerify: React.FunctionComponent<ConfirmOrderVerifyProps> = ({
    token,
    onVerified
}: ConfirmOrderVerifyProps) => {
    const { register, formState, handleSubmit } = useForm()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const onRetrieveOrder = async (data: any) => {
        // Logic to retrieve order based on zipcode and house number
        try {
            setError(null)
            setLoading(true)
            const res = await retrieveOrder({
                token: token || '',
                zipcode: data.zipcode,
                houseNumber: data.houseNumber,
                extension: data.extension
            })
            onVerified(res)
        } catch (error) {
            console.error('Error retrieving order:', error)
            setError('Er is een fout opgetreden bij het ophalen van de opdracht. Probeer het later opnieuw.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className='flex flex-col space-y-2'>
                <h3 className='text-2xl text-center'>Order bevestigen</h3>
                <p className='text-center text-[--tb-text]'>Bevestig allereerst je toegang tot het adres</p>
            </div>
            <form onSubmit={handleSubmit(onRetrieveOrder)} className='flex flex-col space-y-4'>
                <div className='flex flex-wrap md:flex-nowrap space-y-4 md:space-y-0 md:space-x-4 mb-1'>
                    <div className='w-full flex-grow'>
                        <label className='text-sm font-medium text-[--tb-mainHeading] mb-1 block' htmlFor='zipcode'>
                            Postcode
                        </label>
                        <input
                            {...register('zipcode', { required: 'Postcode is verplicht' })}
                            placeholder='Postcode'
                            name='zipcode'
                            id='zipcode'
                            type={'text'}
                            className='w-full'
                        />
                        <ErrorMessage
                            message={
                                typeof formState.errors.zipcode?.message === 'string'
                                    ? formState.errors.zipcode.message
                                    : undefined
                            }
                        />
                    </div>
                    <div className='flex-grow w-full'>
                        <label className='text-sm font-medium text-[--tb-mainHeading] mb-1 block' htmlFor='houseNumber'>
                            Huisnummer
                        </label>
                        <input
                            {...register('houseNumber', {
                                required: 'Huisnummer is verplicht',
                                valueAsNumber: true
                            })}
                            name='houseNumber'
                            id='houseNumber'
                            placeholder='Huisnummer'
                            type={'number'}
                            className='w-full rounded focus:outline-none px-3 py-1.5'
                            min={1}
                        />
                        <ErrorMessage
                            message={
                                typeof formState.errors.houseNumber?.message === 'string'
                                    ? formState.errors.houseNumber.message
                                    : undefined
                            }
                        />
                    </div>
                    <div className='flex-shrink'>
                        <label className='text-sm font-medium text-[--tb-mainHeading] mb-1 block' htmlFor='extension'>
                            Extensie
                        </label>
                        <input
                            {...register('extension')}
                            id='extension'
                            name='extension'
                            placeholder='A'
                            type={'text'}
                            className='w-full'
                        />
                    </div>
                </div>
                <Button type='submit' disabled={!formState.isValid || loading} className='self-end'>
                    {loading ? (
                        <>
                            <DynamicFaIcon iconName='spinner' className='mr-2' spin />
                            Valideren..
                        </>
                    ) : (
                        <span>Volgende stap</span>
                    )}
                </Button>
                {error && <p className='text-red-700 mt-3 text-sm'>{error}</p>}
            </form>
        </>
    )
}
export default ConfirmOrderVerify
